/**
 * Whether online play is configured. Kept apart from client.ts so screens can
 * ask without pulling the Supabase library into the first download.
 */
export const onlineEnabled = Boolean(
  import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY,
);
